export default __webpack_public_path__ + "static/media/cute.d4193d96.gif";